var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.items, function(item, index) {
      return _c(
        "li",
        { key: index, class: { "m-b-5": item.type !== "group" } },
        [
          item.type === "text"
            ? _c("ChangeLogParts", {
                attrs: { parts: item.parts, wide: _vm.wide }
              })
            : item.type === "property"
            ? _c("div", [
                _c("i", [_vm._v("Updated property")]),
                _vm._v(" "),
                _c("div", [
                  _c("strong", [_vm._v(_vm._s(item.key))]),
                  _vm._v(":\n        "),
                  _c(
                    "span",
                    { staticClass: "highlight-diff-old" },
                    [
                      _c("ChangeLogParts", {
                        attrs: { parts: item.before, wide: _vm.wide }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-long-arrow-right" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "highlight-diff-new" },
                    [
                      _c("ChangeLogParts", {
                        attrs: { parts: item.after, wide: _vm.wide }
                      })
                    ],
                    1
                  )
                ])
              ])
            : [
                item.isCollapsible
                  ? _c(
                      "a",
                      {
                        staticClass: "f-s-14 clickable",
                        on: {
                          click: function($event) {
                            _vm.isOpen = !_vm.isOpen
                          }
                        }
                      },
                      [
                        _vm._v(_vm._s(item.heading)),
                        _c("i", {
                          staticClass:
                            "btn btn-function white fa f-s-14 m-l-10",
                          class: _vm.isOpen ? "fa-angle-up" : "fa-angle-down"
                        })
                      ]
                    )
                  : _c("span", {
                      domProps: { textContent: _vm._s(item.heading) }
                    }),
                _vm._v(" "),
                _c("ChangeUpdateChanges", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !item.isCollapsible || _vm.isOpen,
                      expression: "!item.isCollapsible || isOpen"
                    }
                  ],
                  attrs: { items: item.items, wide: _vm.wide }
                })
              ]
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }